import { Component } from '@angular/core';
import { UtilidadesService } from './servicios/utilidades.service';

import { MenuController } from '@ionic/angular';
import { ConexionService } from './servicios/conexion.service';
import { AppUpdateService } from './servicios/update.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  Hijos = []
   slideOpts = {
  slidesPerView: 2,
  }

  OcultarMenu = false;

  Subiendo=false;
  cssSubiendo="inv"

  public appPages = [
    { title: 'Resumen', url: '/home', icon: 'home', PrivRequerido: "" },
    { title: 'Comunicados', url: '/circulares', icon: 'document-text', PrivRequerido: "" },
    { title: 'Calendario escolar', url: '/calendario', icon: 'calendar', PrivRequerido: "" },
    { title: 'Horarios de clase', url: '/horarios', icon: 'time', PrivRequerido: "horarios" },
    { title: 'Actividades', url: '/actividades', icon: 'walk', PrivRequerido: "" },
    // { title: 'Calificaciones', url: '/config-calificaciones', icon: 'ribbon', PrivRequerido: "" },
    { title: 'Contáctanos', url: '/contactanos', icon: 'call', PrivRequerido: "" },
    // { title: 'Comunidad Educativa', url: '/folder/Favorites', icon: 'school', PrivRequerido: "" },
    { title: 'Funciones', url: '/funciones-dash', icon: 'options', PrivRequerido: "funciones-dash" },
    { title: 'Administración', url: '/admin-dash', icon: 'podium', PrivRequerido: "admin-dash" },
   // { title: 'Configuracion', url: '/folder/Spam', icon: 'settings', PrivRequerido: "" },
  ];

  UserOn: boolean = false;
  constructor(public utilidades: UtilidadesService, private menuController: MenuController,
    private conexion: ConexionService, private appupdate: AppUpdateService) {
            
      setInterval(() => {
        this.utilidades.Depuracion("Llamo a doAppUpdate", "console", "")
         appupdate.doAppUpdate()
       }, 15000);
     }
  ngOnInit(): void {
    
    this.utilidades.ocultarMenu$.subscribe((resp:boolean)=>{
      this.OcultarMenu = resp
    })

    this.utilidades.SubirArchivos$.subscribe(media=>{
      this.Cantidad=0
      this.Actual = 0;
      this.progreso = 0;
      this.filename=""
      this.SubirMedia(media, 0)
      this.cssSubiendo="SubiendoArchivos animate__animated animate__lightSpeedInRight"
    })
  //   self.addEventListener('notificationclick', function(event:any) {
  //     log('On notification click: ', event.notification.tag);
  //     // Android doesn't close the notification when you click on it
  //     // See: http://crbug.com/463146
  //     log(event)
  //     event.notification.close();
      
  //     // This looks to see if the current is already open and
  //     // focuses if it is
    
  // });

    this.utilidades.onSesion$.subscribe((val)=>{
      if(val){
        if (localStorage.getItem(btoa("Token"))) {
          this.Hijos = JSON.parse(atob(localStorage.getItem(btoa("Hijos"))))
          this.UserOn = true;
          
        }
      }else{
        this.UserOn = false
      }
    })
    // Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    // Add 'implements OnInit' to the class.
    if (localStorage.getItem(btoa("Token"))) {
      this.Hijos = JSON.parse(atob(localStorage.getItem(btoa("Hijos"))))
      this.UserOn = true;
      
    }else{
      this.UserOn = false;
    }
  }



  Cantidad=0
  Actual = 0;
  progreso = 0;
  filename=""
  SubirMedia(datos, sumando){
    this.Actual+=1
    this.progreso = this.Actual / this.Cantidad;
    let foto = datos[sumando].Foto
    this.filename=foto.name
    this.Cantidad = datos.length
    if (foto.length==0){ 
      this.utilidades.Alerta("No has seleccionado ninguna imagen.")
      return 0; }
    if (foto["type"].indexOf("image/")==-1 && foto["type"].indexOf("video/")==-1){
      this.utilidades.Alerta("Solo se permiten imagenes/videos.")
      return 0;
    }
    this.conexion.SubirMultimediaActividad(foto, datos[sumando].Id, datos[sumando].Tipo).subscribe((resp) => {

      if(sumando+1<this.Cantidad){
        this.SubirMedia(datos, sumando+1)
      }else{
        this.utilidades.Toast("Archivos cargados")
        this.utilidades.nextOntetminoSubida(true)
        this.cssSubiendo="SubiendoArchivos animate__animated animate__lightSpeedOutRight"
      }


    }, (err) => {
      this.utilidades.Toast(err.error.Mensaje)
      if(sumando+1<this.Cantidad){
        this.SubirMedia(datos, sumando+1)
      }else{
        this.utilidades.Toast("Archivos cargados")
        this.cssSubiendo="SubiendoArchivos animate__animated animate__lightSpeedOutRight"
      }
      this.utilidades.ValidarUser(err)
    })
  }
 

  CerrarMenu(){
    setTimeout(() => {
      this.menuController.toggle()
    }, 152);
  }

  CerrarSesion(){
    this.conexion.DesAsociarDispositivoAUsuario(localStorage.getItem("IdDispositivo")).subscribe((resp)=>{
      if(resp.Respuesta=="Exito"){
        localStorage.clear()
        setTimeout(() => {
          location.reload()
        }, 100);
      }
    }, (err)=>{
      this.utilidades.Toast("No se ha podido cerrar sesión")
    })
  }
}
